// @ts-ignore
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="styled-components/cssprop" />

import styled, { createGlobalStyle, keyframes } from 'styled-components';

// Add this new component at the top of the file
export const GlobalStyle = createGlobalStyle`
  body {
    background: linear-gradient(to right, #0F1113, #191540);
    color: white;
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
  }
`;

export const EventGridContainer = styled.div`
  position: relative;
  min-height: 200px; // Adjust this value as needed
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const LoadingSpinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  padding: 20px;
  text-align: center;
`;

export const Container = styled.div<{ paddingTop?: string }>`
  margin: 0 auto;
  padding: 20px;
  padding-top: ${props => props.paddingTop || '150px'};
`;

export const EventGrid = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 10px;
  margin-top: 20px;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  scroll-behavior: smooth;
  margin-left: -20px;
  margin-right: -20px;
  
  // Hide scrollbar for Chrome, Safari and Opera
  &::-webkit-scrollbar {
    display: none;
  }

  // Hide scrollbar for IE, Edge and Firefox
  -ms-overflow-style: none;
  scrollbar-width: none;

  > div:first-child {
    margin-left: 20px;
  }
`;

export const EventCard = styled.div`
  flex: 0 0 200px;
  margin-right: 10px;
  overflow: hidden;
  font-size: 0.8em;
  white-space: normal;
  cursor: pointer;
  border-radius: 4px;
`;

export const EventImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  border: 2px solid transparent;

  ${EventCard}:hover & {
    border-color: white;
  }
`;

export const EventImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease;
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2a2a2a;
  color: #888;
  font-size: 14px;
`;

export const EventContent = styled.div`
  padding: 0px 10px; 
  position: relative;
  min-height: 80px; 
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 1em; // Reduce title font size
    margin-bottom: 5px;
  }
`;

export const BuyButton = styled.a`
  display: inline-block;
  margin-top: auto;
  padding: 5px 10px; // Reduced padding
  text-decoration: none;
  border-radius: 3px; // Slightly reduced border radius
  border: 1px solid #d0d0d0;
  background-color: white;
  color: #333;
  align-self: flex-end;
  transition: background-color 0.2s ease;
  font-size: 0.9em; // Reduce font size
  
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const SourceIcon = styled.img`
  width: 16px; // Reduced from 20px to 16px
  height: 16px; // Reduced from 20px to 16px
  margin-right: 5px; // Reduced from 8px to 5px
  vertical-align: middle;
`;

export const EventDetailContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3px;
  margin-bottom: 3px;
  
  svg {
    color: white;
    opacity: 0.5;
    flex-shrink: 0;
    margin-top: 2px;
  }

  span {
    flex: 1;
    min-width: 0;
  }
`;

export const EventImageOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px;
  text-align: center;
  transform: translateY(100%);
  transition: transform 0.3s ease;

  ${EventCard}:hover & {
    transform: translateY(0);
  }
`;

interface CategoryPillProps {
  color: string;
}

export const CategoryPill = styled.div<CategoryPillProps>`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: ${props => props.color};
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 0.8em;
  display: flex;
  align-items: center;
  gap: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  opacity: 1;

  ${EventCard}:hover & {
    opacity: 1;
  }

  svg {
    font-size: 0.9em;
  }
`;

export const ClickableSpan = styled.span`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const ProviderIcon = styled.img`
  margin-right: 5px;
  width: 1em;
  height: 1em;
  vertical-align: middle;
`;

export const EventRowHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  margin-top: 20px;

  h2 {
    margin: 0;
  }
`;

export const EventRowActions = styled.div`
  display: none;
  gap: 8px;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const ScrollArrow = styled.button`
  background: rgba(0, 0, 0, 0.4);
  border: none;
  border-radius: 50%;
  color: white;
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.8);
  }

  &:disabled {
    background: rgba(255, 255, 255, 0.02);
    color: rgba(255, 255, 255, 0.1);
    cursor: default;
  }
`;
export const EventGridWrapper = styled.div`
  position: relative;
  margin: 0 -20px;
  padding: 0 20px;
`;

const pulse = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
`;

export const SkeletonImage = styled.div`
  width: 100%;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const SkeletonText = styled.span<{width?: string}>`
  display: inline-block;
  width: ${props => props.width || '100%'};
  background: rgba(255, 255, 255, 0.1);
  animation: ${pulse} 1.5s ease-in-out infinite;
  flex: none !important;

  &:before {
    content: '';
    display: inline-block;
  }
`;

export const SkeletonCard = styled(EventCard)`
  pointer-events: none;
  cursor: default;
  
  &:hover ${EventImageContainer} {
    border-color: transparent;
  }
`;

